export default __webpack_public_path__ + "static/media/sony-header.4bd652d2.png";